export default "__VITE_ASSET__DrLhEJgo__"